import { render, staticRenderFns } from "./NavButtonColor.vue?vue&type=template&id=1c54e30e&"
import script from "./NavButtonColor.vue?vue&type=script&lang=js&"
export * from "./NavButtonColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports